import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import Touch from '@/pages/touch'
import Toilet from '@/pages/toilet'
import Search from '@/pages/search'
import ScenicPoiDetail from '@/pages/scenicPoiDetail'
import Map from '@/pages/map'
import specialList from '@/pages/specialList'
import bxqw from '@/pages/bxqw'



Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect() {
        return '/index'
      }
    },
    {
      path: '/index',
      name: 'index',
      component: Index
    },
    // {
    //   path: '/',
    //   name: 'scenicPoiDetail',
    //   component: ScenicPoiDetail
    // },

    // {
    //   path: '/',
    //   name: 'map',
    //   component: Map
    // },
    {
      path: '/map',
      name: 'map',
      component: Map
    },
    {
      path: '/toilet',
      name: 'toilet',
      component: Toilet
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/scenicPoiDetail',
      name: 'scenicPoiDetail',
      component: ScenicPoiDetail
    },
    {
      path: '/specialList',
      name: 'specialList',
      component: specialList
    },
    {
      path: '/bxqw',
      name: 'bxqw',
      component: bxqw
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/Index.js